import request from '@/utils/request';

// 查询绑定分页列表
export function getBindList(options) {
  return request({
    url: '/desk/bind/page',
    method: 'get',
    params: options
  });
}

// 查询学校列表
export function getSchoolList() {
  return request({
    url: '/desk/bind/school/list',
    method: 'get'
  });
}

// 查询年级班级
export function getClassList(options) {
  return request({
    url: '/desk/bind/grade/class/list',
    method: 'get',
    params: options
  });
}

// 批量绑定
export function batchBindingDesk(options) {
  return request({
    url: '/desk/bind/batch',
    method: 'post',
    data: options
  });
}
